import { render, staticRenderFns } from "./Novel_Details.vue?vue&type=template&id=6aca344d&scoped=true&"
import script from "./Novel_Details.vue?vue&type=script&lang=js&"
export * from "./Novel_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca344d",
  null
  
)

export default component.exports